import React from 'react';
import './About.css';

const About = () => {
  return (
    <>
      {/* About Section */}
      <div 
        className="about wow fadeInUp" 
        data-wow-delay="0.1s"
        style={{
          backgroundImage: "url('/img/Aboutus_New.png')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative'
        }}
      >
        <div className="overlay"></div>
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="row about-row">
            <div className="col-lg-5 p-0">
              <div className="about-img">
                <img src="/img/Aboutus_New.png" alt="About Mikan" />
              </div>
            </div>
            <div className="col-lg-7 p-0">
              <div className="about-content">
                <div className="section-header text-left">
                  <h2 style={{ color: '#0e0d0b' }}>About Our Company</h2>
                </div>
                <div className="about-text text-justify">
                  <p>
                    Mikan Group is an engineering consultancy and BIM firm specializing in engineering
                    equipment and structural solutions. With a strong presence in India, Singapore, and
                    Europe, supported by a dedicated team of highly skilled engineers and technicians
                    with over 25 years of collective experience, the company is renowned for its
                    expertise in engineering consultancy, BIM consultancy, and outsourcing services. We
                    collaborate with consulting engineers, architects, and contractors on various
                    projects, from small-scale initiatives to large-scale endeavours, and specialize in
                    providing engineering equipment and structural solutions.
                  </p>
                  <a className="btn" href="/about">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mission Vision Core Values Section */}
      <div className="mvc-section wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="section-header text-center">
            <h2>Our Mission, Vision & Core Values</h2>
          </div>
          <div className="mvc-row wow fadeInUp" data-wow-delay="0.2s">
            <div className="mvc-img">
              <img src="/img/Mission.png" alt="Mission" />
            </div>
            <div className="mvc-text text-justify">
              <h3 style={{ textAlign: 'center' }}>Our Mission</h3>
              <p>
                At Mikan Groups, our mission is to deliver innovative engineering solutions that empower our
                clients and enhance communities. We are committed to excellence, sustainability, and
                integrity in every project we undertake.
              </p>
            </div>
          </div>
          <div className="mvc-row wow fadeInUp" data-wow-delay="0.3s">
            <div className="mvc-img">
              <img src="/img/Value.png" alt="Vision" />
            </div>
            <div className="mvc-text text-justify">
              <h3 style={{ textAlign: 'center' }}>Our Vision</h3>
              <p>
                Our vision is to be a leading engineering firm recognized for our creativity, technical
                expertise, and dedication to sustainable practices. We aspire to shape a better future
                through engineering, driving progress in industries and communities.
              </p>
            </div>
          </div>
          <div className="mvc-row wow fadeInUp" data-wow-delay="0.4s">
            <div className="mvc-img">
              <img src="/img/Vision.png" alt="Core Values" />
            </div>
            <div className="mvc-text text-justify">
              <h3 style={{ textAlign: 'center' }}>Core Values</h3>
              <p>
                Our core values include innovation, sustainability, client satisfaction, and continuous
                improvement. These principles drive us to deliver exceptional results and foster
                long-lasting relationships with our clients and partners.
              </p>
              <br />
              <h4>Client-Centric Solutions: </h4>
              <p>To understand and address the unique needs of our clients, providing tailored engineering solutions that drive success.</p>
              <br />
              <h4>Sustainability:</h4>
              <p>To integrate sustainable practices into all our projects, minimizing environmental impact and promoting resource efficiency.</p>
              <br />
              <h4>Innovation:</h4>
              <p>To leverage cutting-edge technology and innovative approaches in our designs and processes, ensuring we remain at the forefront of the engineering industry.</p>
              <br />
              <h4>Continuous Improvement:</h4>
              <p>To foster a culture of learning and development within our team, encouraging professional growth and adapting to industry advancements.</p>
              <br />
              <h4>Community Engagement:</h4>
              <p>To actively participate in and contribute to the communities we serve, ensuring our projects enhance local infrastructure and quality of life.</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;